// Copyright (c) 2020 Deere & Company

import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';

const LabeledFormInput = props => {

    const errors = props.fields.filter( field => field &&
        ( field.touched || field.initialValue ) && field.error );

    const displayClass = `form-group${props.className ? ` ${props.className}` : ''}${errors.length ? ' error' : ''}`;

    return (
        <div className={displayClass}>
            <label>
                {props.labelNeedsTranslation ?
                    <FormattedMessage id={props.label} /> :
                    <span>{props.label}</span>
                }
            </label>
            {props.isRequired ? ( <span className="asterisk-icon mandatory"><i className="fa fa-asterisk" /></span> ) : ''}
            <span>
                {props.children}
            </span>
        </div>
    );

};

LabeledFormInput.propTypes = {
    children: PropTypes.node.isRequired,
    isRequired: PropTypes.bool,
    className: PropTypes.string,
    fields: PropTypes.array,
    label: PropTypes.string.isRequired,
    labelNeedsTranslation: PropTypes.bool
};
LabeledFormInput.defaultProps = {
    fields: [],
    labelNeedsTranslation: true
};

export default LabeledFormInput;
